import { Injectable } from '@angular/core';

import { Placement } from '@shure/shared/angular/data-access/system-api/models';

import { Mxa7xxBaseLookupTableLoaderService } from '../mxa7xx-base-lookup-table-loader.service';
import { CoveragePerspectives } from '../mxa7xx-lookup-table-loader.api';
import { Mxa7xxModel } from '../mxa7xx-model';

/**
 * Loads look up data tables from files.
 *
 * Application must copy global asset files to local assets folder
 * by adding bellow to 'apps/../app/project.json' targets.build.options.assets array
 *
 * 	{
					"glob": "(Medium|Narrow|Wide)-(angle|cx|cy|rx|ry)-table.csv",
					"input": "./assets/mxa720-lookup-data",
					"output": "./assets/mxa720-lookup-data"
 * 	}
 */

@Injectable({ providedIn: 'root' })
export class Mxa720LookupTableLoaderService extends Mxa7xxBaseLookupTableLoaderService {
	protected readonly lookupDataPath = './assets/mxa720-lookup-data';

	protected readonly supportedTables: Map<CoveragePerspectives, Placement[]> = new Map([
		[CoveragePerspectives.TopDown, [Placement.Ceiling, Placement.Table, Placement.WallHorizontal]],
		[
			CoveragePerspectives.Side,
			[Placement.Ceiling, Placement.Table, Placement.WallHorizontal, Placement.WallVertical]
		]
	]);

	public readonly mxa7xxModel: Mxa7xxModel = Mxa7xxModel.MXA720;
}
